import { mergeAttributes } from "@tiptap/core";
import { Heading as OriginalHeading } from "@tiptap/extension-heading";

import type { Level, HeadingOptions } from "@tiptap/extension-heading";

export const HEADINGS = {
  1: {
    component: "h2",
    className: "text-size-30",
    placeholder: "title.placeholder",
  },
  2: {
    component: "h3",
    className: "text-size-24",
    placeholder: "title.placeholder",
  },
  3: {
    component: "h4",
    className: "text-size-20",
    placeholder: "subSection.placeholder",
  },
} as const;

export const Heading = OriginalHeading.extend<HeadingOptions>({
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5],
      HTMLAttributes: {
        class: "min-w-1 font-semibold",
      },
    };
  },

  parseHTML() {
    return this.options.levels.map((level: Level) => ({
      tag: `h${Math.min(level + 1, 6)}`,
      attrs: { level },
    }));
  },

  renderHTML({ node, HTMLAttributes }) {
    let { level } = node.attrs as { level: Level };

    if (!this.options.levels.includes(level)) {
      level = this.options.levels[0];
    }

    const { className } =
      level in HEADINGS ? HEADINGS[level as keyof typeof HEADINGS] : HEADINGS[3];

    return [
      `h${Math.min(level + 1, 6)}`,
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: className }),
      0,
    ];
  },
});
